import { ThemeConfig } from 'antd';

// 配置antd风格
export const customAntdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#002cda',
    borderRadius: 4,
  },
  components: {
    Message: {},
    Tabs: {
      cardPadding: '0',
    },
  },
};
